import { s3upload } from "../api/aws"

const uploadImageHandler = async (file, resolve, reject) => {
    try {
        const imageObj = await s3upload(file, () => { }, "institutes/mocktest/images/image_")
        resolve({ default: imageObj.uri })
    } catch (err) {
        console.log(err)
        reject(err)
    }

}

function uploadAdapter(loader) {
    return {
        upload: () => {
            return new Promise((resolve, reject) => {
                loader.file.then((file) => {
                    return uploadImageHandler(file, resolve, reject)
                });
            })
        }
    };
}


export default function CKEditorImageUpload(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return uploadAdapter(loader);
    };
}

export const replaceImageSrc = (imgSrc) => {
    const currentOrigin = window.location.origin;
    const cloudfrontURL = "https://d2dn8tqui3vt36.cloudfront.net";

    // Ensure the URL has an origin; if not, prepend window.location.origin
    let normalizedSrc = imgSrc.startsWith("http") ? imgSrc : `${currentOrigin}${imgSrc}`;

    // Replace multiple consecutive slashes (`///`) with a single slash, but keep `http://` or `https://` intact
    normalizedSrc = normalizedSrc.replace(/([^:]\/)\/+/g, "$1");

    // Replace current origin with CloudFront CDN URL
    return normalizedSrc.replace(new RegExp(`^${currentOrigin}`), cloudfrontURL);
};